export const PAGE_FETCHED = "PAGE_FETCHED";
export const META_FETCHED = "META_FETCHED";
export const FOOTER_FETCHED = "FOOTER_FETCHED";
export const LOADED = "LOADED";
export const NAV_FETCHED = "NAV_FETCHED";
export const ROUTE_FETCHED = "ROUTE_FETCHED";
export const MODAL_FETCHED = "MODAL_FETCHED";
export const FILTER_FETCHED = "FILTER_FETCHED";
export const CSRF_FETCHED = "CSRF_FETCHED";
export const CTA_FETCHED = "CTA_FETCHED";
export const STANDARDS_FETCHED = "STANDARDS_FETCHED";


// WEBPACK FOOTER //
// ./src/types.js